// ═══════════════════════════════════════════════════════════════════════════════
// Pin Message Types
// ═══════════════════════════════════════════════════════════════════════════════
export const PIN_MESSAGE_VISIBILITY = {
    EMPLOYER_ONLY: 'employer_only',
    BOTH: 'both',
};
export const PIN_MESSAGE_ICON = {
    INFO: 'info',
    REMIND: 'remind',
    SPECIAL_ALERT: 'special_alert',
};
//# sourceMappingURL=pinMessage.js.map